var sw = require('js/lib/sw');
var $ = require('js/sw-jquery/sw-jquery');
var notifications = require('js/lib/notifications/sw-notifications');

function switchTab(e) {
  e.preventDefault();
  var $el = $(e.target);
  var $tab = $el.parent();
  $.ajax({
    type: 'GET',
    async: true,
    url: '/shop/' + $el.attr('id'),
    success: function(data) {
      if(!$tab.hasClass('tabs-nav-selected')) {
        $('.tabs-nav-selected').removeClass('tabs-nav-selected');
        $tab.addClass('tabs-nav-selected');
      }

      var $fragment = $(data);
      sw.trigger('sw-fragment-loaded', $fragment);

      $('#tab-content').html('').append($fragment);
    }
  });
}
$('[data-sw-tab-settings], [data-sw-tab-payment-info]').click(switchTab);

function removeErrorClass(){
  $(this).removeClass('obligatory');
  $(this).parent('.input-group').removeClass('obligatory');
}

function hideNotifications() {
  $('#email-error-text').html('').hide();
}

$('body').on('click', '[data-sw-update-payment-info]', function updatePaymentInfo() {
  hideNotifications();

  var form = $('#payment-info-form');
  var url = '/shop/tab-payment-info';

  $.ajax({
    type: 'POST',
    url: url,
    data: form.serialize(),
    dataType: 'json',
    success: function(response) {
      if (!response.success) {
        notifications.error(response.errorMessage);
        if(response.emailErrorMessage) {
          $('#email-error-text').html(response.emailErrorMessage).show();
        }
      } else {
        notifications.success(response.successMessage);
      }

      $('#billingAddress').html(response.addressContent);
      $('.obligatory').focus(removeErrorClass);
    }

  });
});

function toggleStatesForPriceComparisonDownload(toggleInitialState) {
  if(toggleInitialState){
    $('[data-sw-pricing-comparison-container]').toggleClass('sw--is-hidden');
  }
  else {
    $('[data-sw-download-state-container]').removeClass('sw--is-hidden');
  }

  $('[data-sw-loading-state-container]').toggleClass('sw--is-hidden');
}

function toggleStatesForPricingComparisonReady(timeStamp) {
  $('[data-sw-pricing-comparison-container]').removeClass('sw--is-hidden');
  $('[data-sw-download-state-container]').addClass('sw--is-hidden');

  var arr = timeStamp.split('-');
  // the actual download
  window.location = '/shop/download-pricing-comparison-csv?d=1&time=' + arr[1] + '&userId=' + arr[0];
}

function triggerCSVPolling(timeStamp) {
  var params = {
    'timeStamp': timeStamp
  };
  sw.polling(
    '/pricing-comparison-csv-polling',
    function () {
      //toggle UI to allow users to ask for another csv 
      toggleStatesForPricingComparisonReady(timeStamp);
    },
    10000,
    params
  );
}

$('body').on('click', '[data-sw-pricing-comparison-download-btn]', function (e) {

  e.stopPropagation();
  e.preventDefault();

  var $el = $(e.target).closest('form');
  var formData = $el.swFormValues();
  var dateTime = Date.now();
  var timeStamp = Math.floor(dateTime / 1000);
  var userId = sw.data.userId;
  toggleStatesForPriceComparisonDownload(true);
  formData.time = timeStamp;

  if (!formData.userId) {
    formData.userId = userId;
  }

  $.ajax({
    type: 'get',
    url: '/shop/download-pricing-comparison-csv',
    data: formData,
    success: function () {
      toggleStatesForPriceComparisonDownload(false);
      triggerCSVPolling(formData.userId + '-' + timeStamp);
    }
  });
});
